import React, { Component, isValidElement } from 'react';
import { message } from 'antd';

import { callApi } from './callApi';

function getHash() {
  return window.Math.random().toString(36).substr(2, 6);
}

class Content extends Component {
  static defaultProps = {
    datas: [],
  }
  render() {
    const { datas } = this.props;
    return (
      <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
        <p>{datas[0].title}:</p>
        {
          datas.map(data => (
            <p key={data.messageUnitId}>
              {data.context}
              <a
                href={data.linkUrl}
                target='_blank'
                rel='noopener'
                onClick={() => {
                  const { onClick } = this.props;
                  typeof onClick === 'function' && onClick(data);
                }}
              >查看详情</a>
            </p>
          ))
        }
      </div>
    )
  }
}

class MessageCenter {
  constructor() {
    this.id = getHash();
    this.socket = null;
    this.socketType = 'interval';
    this.content = null;
    this.currentInterval = false;
  }
  onOpen = () => { }
  onClose = () => { }
  onError = () => { }
  onMessage = () => { }
  onViewDetails = data => {
    callApi('/api/ec/dev/message/statemessage', 'GET', { id: data.messageUnitId });
  }
  setContent(com) {
    this.content = com;
  }
  init = () => {
    // if ('WebSocket' in window) {
    //   this.socketType = 'websocket';
    //   this.socket = new WebSocket();
    //   this.socket.onopen = this.onOpen;
    //   this.socket.onerror = this.onClose;
    //   this.socket.onclose = this.onError;
    //   this.socket.onmessage = this.onMessage;
    // } else {
    const interval = () => {
      if (!/.*\/wui\/index.*/.test(window.location.href)) {
        return;
      }
      callApi('/api/ec/dev/message/getmessage', 'GET', {}).then(res => {
        if (res.status === true) {
          const { datas } = res;
          if (datas.length > 0) {
            const props = {
              datas,
              onClick: data => {
                this.onViewDetails(data);
              },
            };
            const content = !this.content
              ? <Content {...props} />
              : isValidElement(this.content)
                ? <this.content {...props} />
                : this.content;
            message.error(content, 10);
            this.onMessage(res);
          }
        }
      })
    }
      this.socketType = 'interval';
      this.socket = window.setInterval(interval, 60000);
      interval();
    // }
  }
  send = (params = {}) => {
    if (this.socket) {
      this.socketType === 'interval'
        ? callApi('/api/ec/dev/message/sendmessage', 'POST', params).then(res => {
          if (res.status === true) {
            this.onMessage(res);
          } else {
            this.onError(res);
          }
        })
        : this.socket.send(params);
    }
  }
  close = () => {
    if (this.socket) {
      if (this.socketType === 'interval') {
        clearInterval(this.socket);
        this.onClose();
        this.socket = null;
        // window.sessionStorage.removeItem('e9_message_center_interval');
      } else {
        this.socket.close();
      }
    }
  }
}

export default new MessageCenter();



// WEBPACK FOOTER //
// ./ecology9/wea-tools/messageCenter.js